import { useContext, useState, lazy } from 'react';
import { projectImages } from '../../../public/Assets/Images';
import TypoGraphy, { Variants } from '@/typography';
import Button from '../Button';
import Checkbox from '../Checkbox';
import './index.scss';
import { useParams, usePathname } from 'next/navigation';
import { RouteStrings } from '@/utils/routestrings';
import { AppContext } from '@/contexts/appcontext';
import { getSlugAndRouteName } from '@/utils/Functions';
import SubTopicList from '@/reusablecomponents/SubTopicList';
import ContentsCard from '@/reusablecomponents/TableOfContents';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Image from 'next/image';
import { gumletLoader } from '@/utils/gumlet';
import VideoDetailCard from '@/reusablecomponents/VideoCourseCard';
const MobileModal = lazy(() => import('@/reusablecomponents/Modals/MobileModal'));
const MobileFilter = ({
  data,
  currentSubIndustry,
  toc,
  videoCardData,
  nextSchedule,
  leraningClick,
  articleRef,
  articleData
}: any) => {
  const {
    isAll,
    setIsAll,
    isAdvanced,
    setisAdvanced,
    isIntermediate,
    setIntermediate,
    isBeginner,
    setIsBeginner
  } = useContext<any>(AppContext);
  const [industryModal, setindustryModal] = useState(false);
  const [expertiseModal, setexpertiseModal] = useState(false);
  const [topicModal, setTopicModal] = useState(false);
  const [videoCourseModal, setVideoCourseModal] = useState(false);
  const [tocModal, setTocModal] = useState(false);
  const params = useParams();
  const {
    isTopic,
    isSubTopic,
    isArticle
  } = getSlugAndRouteName(params?.route?.toString() ?? '');
  const isVideoCourseModal = true;
  const pathname = usePathname();
  const subTopics = data?.data[0]?.attributes?.subTopics;
  const handleModalClose = () => {
    if (industryModal) setindustryModal(false);
    if (expertiseModal) setexpertiseModal(false);
    if (topicModal) setTopicModal(false);
    if (videoCourseModal) setVideoCourseModal(false);
    if (tocModal) setTocModal(false);
  };
  const handleMentor = () => {
    setIsAll({
      checked: false,
      state: true
    });
  };
  const handleClear = () => {
    setIsAll({
      checked: false,
      state: true
    });
  };
  const handleApply = () => {
    setexpertiseModal(false);
  };
  const handlePDF = async () => {
    const padding = 20;
    const articleElement = articleRef.current;
    if (!articleElement) return;
    const pdf = new jsPDF('p', 'pt', 'a4', true);
    const articleHeight = articleElement.scrollHeight;
    let currentPosition = 0;
    const chunkSize = 500;
    const captureChunk = async (position: number): Promise<boolean> => {
      try {
        const remainingHeight = articleHeight - position;
        const chunkHeight = Math.min(chunkSize, remainingHeight);
        const canvas = await html2canvas(articleElement, {
          height: chunkHeight,
          y: position
        });
        const imgData = canvas.toDataURL('image/png');
        const aspectRatio = canvas.width / canvas.height;
        const width = pdf.internal.pageSize.width - 2 * padding;
        const height = width / aspectRatio;
        pdf.addImage(imgData, 'PNG', padding, padding, width, height, '', 'FAST');

        // Clean up canvas
        canvas.remove();
        return position + chunkHeight < articleHeight;
      } catch (error) {
        console.error('Error capturing PDF chunk:', error);
        return false;
      }
    };
    try {
      let hasMoreChunks = true;
      while (hasMoreChunks) {
        hasMoreChunks = await captureChunk(currentPosition);
        if (hasMoreChunks) {
          currentPosition += chunkSize;
          pdf.addPage();
        }
      }
      pdf.save(`${articleData.attributes.title}.pdf`);
    } catch (error) {
      console.error('PDF generation failed:', error);
    }
  };
  const getSubIndustryFont = (subIndustry: string): Variants => {
    if (currentSubIndustry === subIndustry) return 'Mobile/Body 2/M | 14 | 120';
    return 'Mobile/Body 2';
  };
  if (pathname.includes("/topics")) {
    return <></>;
  }
  return <>
            <div className="mobile_filter_wrapper">
                {isTopic || isSubTopic ? <div className="start_learning_wrapper">
                    <Button text='Start Learning' variant='NormalVariant' textColor='white' backgroundColor='black' textVariant='Desktop/Body 2/M | 14 |120' clickHandler={leraningClick} />
                </div> : isArticle ? <>
                            <div className='toc_wrapper' onClick={() => setTocModal(true)}>
                                <img src={projectImages.tableOfContent}></img>
                            </div>
                            <div className='mobile_filter'>
                                <div className="filter_item_topic" onClick={() => setTopicModal(true)}>
                                    <img src={projectImages.industryFilterIcon} alt="industry" />
                                    <TypoGraphy text='Topics' variant='Mobile/Body 2/M | 14 | 120' />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1" height="23" viewBox="0 0 1 23" fill="none">
                                    <path d="M0.5 1L0.499999 22" stroke="#030A21" strokeOpacity="0.3" strokeLinecap="round" />
                                </svg>

                                {isVideoCourseModal && <div className="filter_item_topic" onClick={() => setVideoCourseModal(true)}>
                                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.75 17H11.25C15 17 16.5 15.5 16.5 11.75V7.25C16.5 3.5 15 2 11.25 2H6.75C3 2 1.5 3.5 1.5 7.25V11.75C1.5 15.5 3 17 6.75 17Z" stroke="#030A21" strokeWidth="1.07143" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M6.82617 9.50158V8.39158C6.82617 6.95908 7.83867 6.38158 9.07617 7.09408L10.0362 7.64908L10.9962 8.20408C12.2337 8.91658 12.2337 10.0866 10.9962 10.7991L10.0362 11.3541L9.07617 11.9091C7.83867 12.6216 6.82617 12.0366 6.82617 10.6116V9.50158Z" stroke="#030A21" strokeWidth="1.07143" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <TypoGraphy text='Video Course' variant='Mobile/Body 2/M | 14 | 120' />
                                </div>}
                                {isVideoCourseModal && <svg xmlns="http://www.w3.org/2000/svg" width="1" height="23" viewBox="0 0 1 23" fill="none">
                                        <path d="M0.5 1L0.499999 22" stroke="#030A21" strokeOpacity="0.3" strokeLinecap="round" />
                                    </svg>}

                                <div className="filter_item_topic" onClick={() => handlePDF()}>
                                    <img src={projectImages.downloadIconOutlined}></img>
                                    {!isVideoCourseModal && <TypoGraphy text='Download PDF' variant='Mobile/Body 2/M | 14 | 120' />}
                                </div>
                            </div>
                        </> : <div className="mobile_filter">
                            <div className="industry filter_item" onClick={() => setindustryModal(true)}>
                                <Image loader={gumletLoader} width={17} height={17} src={projectImages.industryFilterIcon} alt="industry" />
                                <TypoGraphy text='Industry' variant='Mobile/Body 2/M | 14 | 120' />
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="1" height="23" viewBox="0 0 1 23" fill="none">
                                <path d="M0.5 1L0.499999 22" stroke="#030A21" strokeOpacity="0.3" strokeLinecap="round" />
                            </svg>
                            <div className="expertise filter_item" onClick={() => setexpertiseModal(true)}>
                                <Image loader={gumletLoader} width={17} height={17} src={projectImages.chartIconEmpty} alt="expertise" />
                                <TypoGraphy text='Expertise' variant='Mobile/Body 2/M | 14 | 120' />
                            </div>
                        </div>}
            </div>
            {(industryModal || expertiseModal || topicModal || videoCourseModal) && <MobileModal closehandler={handleModalClose}>
                    <>
                        {industryModal && <div className="industry_content_wrapper">
                            <div className="heading_wrapper">
                                <TypoGraphy text='Industry' variant='Desktop/Heading 1/M | 20 |120' />
                            </div>
                            <div className="category_content">
                                {data?.data?.map((item: any, index: number) => {
              return <div className="category_content_wrapper" key={`content_index_${index}`}>
                                            <div className="content_heading">
                                                <TypoGraphy tagName='a' isArticle href={RouteStrings.DYNAMICROUTE(item?.attributes?.industryName, 'INDUSTRY', item?.id)} title={`Free ${item?.attributes?.industryName} Courses`} text={item.attributes.industryName} variant='Mobile/Body 1/M | 16 | 160' />
                                            </div>
                                            <div className="content_list">
                                                {item?.attributes?.subIndustries?.data?.map((element: any, index: number) => <div key={`sub_indutry_modal_${index}`}>
                                                    <TypoGraphy text={element?.attributes?.subIndustry} tagName='a' title={`Free ${element?.attributes?.subIndustry} Courses`} href={RouteStrings.DYNAMICROUTE(element?.attributes?.subIndustry, 'SUBINDUSTRY', element?.id)} isArticle variant={getSubIndustryFont(element?.attributes?.subIndustry)} key={`item_${index}`} /> </div>)}
                                            </div>
                                        </div>;
            })}
                            </div>
                        </div>}
                        {expertiseModal && <div className="expertise_content_wrapper">
                            <div className="heading_wrapper">
                                <TypoGraphy text='Expertise' variant='Desktop/Heading 1/M | 20 |120' />
                            </div>
                            <div className="middle_section">
                                <Checkbox text={'Beginner'} isActive={isBeginner} setIsActive={setIsBeginner} textVariant='Mobile/Body 2/R | 14 | 160' />
                                <Checkbox text={'Intermediate'} isActive={isIntermediate} setIsActive={setIntermediate} textVariant='Mobile/Body 2/R | 14 | 160' />
                                <Checkbox text={'Advanced'} isActive={isAdvanced} setIsActive={setisAdvanced} textVariant='Mobile/Body 2/R | 14 | 160' />
                                <Checkbox text={'All'} isActive={isAll.checked} setIsActive={() => setIsAll({
              checked: true,
              state: true
            })} textVariant='Mobile/Body 2/R | 14 | 160' />
                            </div>
                            <div className="bottom_section">
                                <Button text='Clear Filters' textVariant='Mobile/Body 1/M | 16 | 120' variant='NormalVariant' textColor='black' backgroundColor='white' borderColor='#030A214D' clickHandler={handleClear} />
                                <Button text='Apply' textVariant='Mobile/Body 1/M | 16 | 120' variant='NormalVariant' backgroundColor='black' textColor='white' clickHandler={handleApply} />
                            </div>
                        </div>}
                        {topicModal && <div className='topic_content_wrapper'>
                            <div className='title_wrapper'>
                                <TypoGraphy text={`Learn ${data.data[0].attributes.topicName}`} variant='Desktop/Heading 1/M | 20 |120'></TypoGraphy>
                            </div>
                            <div>
                                <div className="subtopic_list_wrapper">
                                    {subTopics.map((subtopic: any, index: number) => {
                return <div className={`sub_topic`} key={`sub_topic_${index}`}>
                                                <SubTopicList data={subtopic} />
                                            </div>;
              })}
                                </div>
                            </div>
                        </div>}
                        {videoCourseModal && <div className='video_course_modal'>
                            <div className=''>
                                <VideoDetailCard data={videoCardData} nextSchedule={nextSchedule} handleButtonClick={handleMentor} />
                            </div>
                        </div>}
                    </>
                </MobileModal>}
            {isArticle && tocModal && <MobileModal closehandler={handleModalClose}>
                    <>
                        {tocModal && <div className='toc_modal'>
                            <ContentsCard headings={toc} closehandler={handleModalClose}></ContentsCard>
                        </div>}
                    </>
                </MobileModal>}


        </>;
};
export default MobileFilter;